import { render, staticRenderFns } from "./TitleListSortingSwitcher.vue?vue&type=template&id=148cadda&scoped=true"
import script from "./TitleListSortingSwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleListSortingSwitcher.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleListSortingSwitcher.vue?vue&type=style&index=0&id=148cadda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148cadda",
  null
  
)

export default component.exports